import react, { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import {
    Button,
    MenuItem,
    TextField,
    Typography
} from '@mui/material';

import App from 'elements/HtmlEditor/App';
import Box from 'elements/Box';
import { ProjectConfig } from 'Global';
import LangTabs from 'elements/LangTabs';

import 'assets/css/main.css';

import { TextosLiturgicos, fakeAPIEditor } from './TextosLiturgicosList';
import axios from 'axios';

const defaultValues ={
    texto_liturgico_id: 'null',
    tiempo: "tiempo_ordinario",
    dia: "6",
    semana: 1,
    color: "Verde",
    oficio_lectura: null,
    laudes: null,
    horas_intermedias: null,
    visperas: null,
    completas: null,

    lecturas_ano_1: null,
    reflexiones_ano_1: null,
    lectio_divina_ano_1: null,

    lecturas_ano_2: null,
    reflexiones_ano_2: null,
    lectio_divina_ano_2: null,

    lecturas_dominical_a: null,
    reflexiones_dominical_a: null,
    lectio_divina_dominical_a: null,

    lecturas_dominical_b: null,
    reflexiones_dominical_b: null,
    lectio_divina_dominical_b: null,
    
    lecturas_dominical_c: null,
    reflexiones_dominical_c: null,
    lectio_divina_dominical_c: null

}

// 'reflexiones_dominical_a' => $reflexiones_dominical_a,
// 'lectio_divina_dominical_a' => $lectio_divina_dominical_a,

export default function TextosLiturgicosEditor ( props: any ) {

    const semanaArray = Array.from({length: 35}, (_, i) => i + 1);

    const navigate = useNavigate();

    const { texto_liturgico_id = 'null' } = useParams();

    const [formValues, setFormValues] = useState<any>({...defaultValues, texto_liturgico_id: texto_liturgico_id});

    const [oficio, setOficio] = useState<any>(null);
    const [laudes, setLaudes] = useState<any>(null);
    const [horas, setHoras] = useState<any>(null);
    const [visperas, setVisperas] = useState<any>(null);
    const [completas, setCompletas] = useState<any>(null);

    const [lecturasAño1, setLecturasAño1] = useState<any>(null);
    const [lecturasAño1reflexiones, setLecturasAño1reflexiones] = useState<any>(null);
    const [lecturasAño1lectio_divina, setLecturasAño1lectio_divina] = useState<any>(null);

    const [lecturasAño2, setLecturasAño2] = useState<any>(null);
    const [lecturasAño2reflexiones, setLecturasAño2reflexiones] = useState<any>(null);
    const [lecturasAño2lectio_divina, setLecturasAño2lectio_divina] = useState<any>(null);

    const [dominicalAñoA, setDominicalAñoA] = useState<any>(null);
    const [dominicalAñoAreflexiones, setDominicalAñoAreflexiones] = useState<any>(null);
    const [dominicalAñoAlectio_divina, setDominicalAñoAlectio_divina] = useState<any>(null);

    const [dominicalAñoB, setDominicalAñoB] = useState<any>(null);
    const [dominicalAñoBreflexiones, setDominicalAñoBreflexiones] = useState<any>(null);
    const [dominicalBñoBlectio_divina, setDominicalAñoBAlectio_divina] = useState<any>(null);

    const [dominicalAñoC, setDominicalAñoC] = useState<any>(null);
    const [dominicalAñoCreflexiones, setDominicalAñoCreflexiones] = useState<any>(null);
    const [dominicalAñoClectio_divina, setDominicalAñoCAlectio_divina] = useState<any>(null);

    // i18n: idioma actual y traducciones
    const [currentLangId, setCurrentLangId] = useState<string>("1");
    const [translations, setTranslations] = useState<Record<string, any>>({});

    // Helper para actualizar traducciones
    const updateTranslation = (field: string, value: any) => {
        setTranslations(prev => ({
            ...prev,
            [currentLangId]: {
                ...prev[currentLangId],
                [field]: value
            }
        }));
    };

    // Handler para cambio de idioma
    const handleLangChange = (newLangId: string) => {
        setCurrentLangId(newLangId);
        // Actualizar los editores con el contenido del nuevo idioma
        const trans = translations[newLangId];
        if (trans) {
            setOficio(trans.oficio_lectura || null);
            setLaudes(trans.laudes || null);
            setHoras(trans.horas_intermedias || null);
            setVisperas(trans.visperas || null);
            setCompletas(trans.completas || null);
            setLecturasAño1(trans.lecturas_ano_1 || null);
            setLecturasAño1reflexiones(trans.reflexiones_ano_1 || null);
            setLecturasAño1lectio_divina(trans.lectio_divina_ano_1 || null);
            setLecturasAño2(trans.lecturas_ano_2 || null);
            setLecturasAño2reflexiones(trans.reflexiones_ano_2 || null);
            setLecturasAño2lectio_divina(trans.lectio_divina_ano_2 || null);
            setDominicalAñoA(trans.lecturas_dominical_a || null);
            setDominicalAñoAreflexiones(trans.reflexiones_dominical_a || null);
            setDominicalAñoAlectio_divina(trans.lectio_divina_dominical_a || null);
            setDominicalAñoB(trans.lecturas_dominical_b || null);
            setDominicalAñoBreflexiones(trans.reflexiones_dominical_b || null);
            setDominicalAñoBAlectio_divina(trans.lectio_divina_dominical_b || null);
            setDominicalAñoC(trans.lecturas_dominical_c || null);
            setDominicalAñoCreflexiones(trans.reflexiones_dominical_c || null);
            setDominicalAñoCAlectio_divina(trans.lectio_divina_dominical_c || null);
        } else {
            // Vacío si no hay traducción
            setOficio(null);
            setLaudes(null);
            setHoras(null);
            setVisperas(null);
            setCompletas(null);
            setLecturasAño1(null);
            setLecturasAño1reflexiones(null);
            setLecturasAño1lectio_divina(null);
            setLecturasAño2(null);
            setLecturasAño2reflexiones(null);
            setLecturasAño2lectio_divina(null);
            setDominicalAñoA(null);
            setDominicalAñoAreflexiones(null);
            setDominicalAñoAlectio_divina(null);
            setDominicalAñoB(null);
            setDominicalAñoBreflexiones(null);
            setDominicalAñoBAlectio_divina(null);
            setDominicalAñoC(null);
            setDominicalAñoCreflexiones(null);
            setDominicalAñoCAlectio_divina(null);
        }
    };
    
    useEffect (() => {
        if (texto_liturgico_id !== 'null') {
            loadData();
        }
        
    }, [texto_liturgico_id]);

    const loadData = () => {
        axios.get(ProjectConfig.api_url, {
            params: {
                request: 'textos_liturgicos_details',
                texto_liturgico_id: texto_liturgico_id
            }
        })
        .then(function (response) {
            console.log(response.data);

            const loadedTranslations = response.data.translations || {};
            const initialContent = loadedTranslations["1"] || response.data;

            setFormValues(response.data);
            setTranslations(loadedTranslations);

            setOficio(initialContent.oficio_lectura || null);
            setLaudes(initialContent.laudes || null);
            setHoras(initialContent.horas_intermedias || null);
            setVisperas(initialContent.visperas || null);
            setCompletas(initialContent.completas || null);

            setLecturasAño1(initialContent.lecturas_ano_1 || null);
            setLecturasAño1reflexiones(initialContent.reflexiones_ano_1 || null);
            setLecturasAño1lectio_divina(initialContent.lectio_divina_ano_1 || null);

            setLecturasAño2(initialContent.lecturas_ano_2 || null);
            setLecturasAño2reflexiones(initialContent.reflexiones_ano_2 || null);
            setLecturasAño2lectio_divina(initialContent.lectio_divina_ano_2 || null);

            setDominicalAñoA(initialContent.lecturas_dominical_a || null);
            setDominicalAñoAreflexiones(initialContent.reflexiones_dominical_a || null);
            setDominicalAñoAlectio_divina(initialContent.lectio_divina_dominical_a || null);

            setDominicalAñoB(initialContent.lecturas_dominical_b || null);
            setDominicalAñoBreflexiones(initialContent.reflexiones_dominical_b || null);
            setDominicalAñoBAlectio_divina(initialContent.lectio_divina_dominical_b || null);

            setDominicalAñoC(initialContent.lecturas_dominical_c || null);
            setDominicalAñoCreflexiones(initialContent.reflexiones_dominical_c || null);
            setDominicalAñoCAlectio_divina(initialContent.lectio_divina_dominical_c || null);
        })
        .catch(function (error) {
            console.log(error);
        });
    }


    const handleOficioChange = (htmlContent: any, jsonContent: any) => {
        if (currentLangId === "1") {
            setFormValues((prev: any) => ({...prev, oficio_lectura: jsonContent}));
        } else {
            updateTranslation('oficio_lectura', jsonContent);
        }
    }

    const handleLaudesChange = (htmlContent: any, jsonContent: any) => {
        if (currentLangId === "1") {
            setFormValues((prev: any) => ({...prev, laudes: jsonContent}));
        } else {
            updateTranslation('laudes', jsonContent);
        }
    }

    const handleHorasChange = (htmlContent: any, jsonContent: any) => {
        if (currentLangId === "1") {
            setFormValues((prev: any) => ({...prev, horas_intermedias: jsonContent}));
        } else {
            updateTranslation('horas_intermedias', jsonContent);
        }
    }

    const handleVisperasChange = (htmlContent: any, jsonContent: any) => {
        if (currentLangId === "1") {
            setFormValues((prev: any) => ({...prev, visperas: jsonContent}));
        } else {
            updateTranslation('visperas', jsonContent);
        }
    }

    const handleCompletasChange = (htmlContent: any, jsonContent: any) => {
        if (currentLangId === "1") {
            setFormValues((prev: any) => ({...prev, completas: jsonContent}));
        } else {
            updateTranslation('completas', jsonContent);
        }
    }

    // AÑO1

    const handleLecturasAño1Change = (htmlContent: any, jsonContent: any) => {
        if (currentLangId === "1") {
            setFormValues((prev: any) => ({...prev, lecturas_ano_1: jsonContent}));
        } else {
            updateTranslation('lecturas_ano_1', jsonContent);
        }
    }
    const handleLecturasAño1ChangeReflexiones = (htmlContent: any, jsonContent: any) => {
        if (currentLangId === "1") {
            setFormValues((prev: any) => ({...prev, reflexiones_ano_1: jsonContent}));
        } else {
            updateTranslation('reflexiones_ano_1', jsonContent);
        }
    }
    const handleLecturasAño1ChangeLeticio = (htmlContent: any, jsonContent: any) => {
        if (currentLangId === "1") {
            setFormValues((prev: any) => ({...prev, lectio_divina_ano_1: jsonContent}));
        } else {
            updateTranslation('lectio_divina_ano_1', jsonContent);
        }
    }

    // AÑO 2

    const handleLecturasAño2Change = (htmlContent: any, jsonContent: any) => {
        if (currentLangId === "1") {
            setFormValues((prev: any) => ({...prev, lecturas_ano_2: jsonContent}));
        } else {
            updateTranslation('lecturas_ano_2', jsonContent);
        }
    }

    const handleLecturasAño2ChangeReflexiones = (htmlContent: any, jsonContent: any) => {
        if (currentLangId === "1") {
            setFormValues((prev: any) => ({...prev, reflexiones_ano_2: jsonContent}));
        } else {
            updateTranslation('reflexiones_ano_2', jsonContent);
        }
    }
    const handleLecturasAño2ChangeLeticio = (htmlContent: any, jsonContent: any) => {
        if (currentLangId === "1") {
            setFormValues((prev: any) => ({...prev, lectio_divina_ano_2: jsonContent}));
        } else {
            updateTranslation('lectio_divina_ano_2', jsonContent);
        }
    }

    // DOMINICAL A

    const handleDominicalAñoAChange = (htmlContent: any, jsonContent: any) => {
        if (currentLangId === "1") {
            setFormValues((prev: any) => ({...prev, lecturas_dominical_a: jsonContent}));
        } else {
            updateTranslation('lecturas_dominical_a', jsonContent);
        }
    }
    const handleDominicalAñoAChangeReflexiones = (htmlContent: any, jsonContent: any) => {
        if (currentLangId === "1") {
            setFormValues((prev: any) => ({...prev, reflexiones_dominical_a: jsonContent}));
        } else {
            updateTranslation('reflexiones_dominical_a', jsonContent);
        }
    }
    const handleDominicalAñoAChangeLeticio = (htmlContent: any, jsonContent: any) => {
        if (currentLangId === "1") {
            setFormValues((prev: any) => ({...prev, lectio_divina_dominical_a: jsonContent}));
        } else {
            updateTranslation('lectio_divina_dominical_a', jsonContent);
        }
    }

    // DOMINICAL B
    const handleDominicalAñoBChange = (htmlContent: any, jsonContent: any) => {
        if (currentLangId === "1") {
            setFormValues((prev: any) => ({...prev, lecturas_dominical_b: jsonContent}));
        } else {
            updateTranslation('lecturas_dominical_b', jsonContent);
        }
    }

    const handleDominicalAñoBChangeReflexiones = (htmlContent: any, jsonContent: any) => {
        if (currentLangId === "1") {
            setFormValues((prev: any) => ({...prev, reflexiones_dominical_b: jsonContent}));
        } else {
            updateTranslation('reflexiones_dominical_b', jsonContent);
        }
    }
    const handleDominicalAñoBChangeLeticio = (htmlContent: any, jsonContent: any) => {
        if (currentLangId === "1") {
            setFormValues((prev: any) => ({...prev, lectio_divina_dominical_b: jsonContent}));
        } else {
            updateTranslation('lectio_divina_dominical_b', jsonContent);
        }
    }
    
    // DOMINICAL C

    const handleDominicalAñoCChange = (htmlContent: any, jsonContent: any) => {
        if (currentLangId === "1") {
            setFormValues((prev: any) => ({...prev, lecturas_dominical_c: jsonContent}));
        } else {
            updateTranslation('lecturas_dominical_c', jsonContent);
        }
    }

    const handleDominicalAñoCChangeReflexiones = (htmlContent: any, jsonContent: any) => {
        if (currentLangId === "1") {
            setFormValues((prev: any) => ({...prev, reflexiones_dominical_c: jsonContent}));
        } else {
            updateTranslation('reflexiones_dominical_c', jsonContent);
        }
    }
    const handleDominicalAñoCChangeLeticio = (htmlContent: any, jsonContent: any) => {
        if (currentLangId === "1") {
            setFormValues((prev: any) => ({...prev, lectio_divina_dominical_c: jsonContent}));
        } else {
            updateTranslation('lectio_divina_dominical_c', jsonContent);
        }
    }

    

    const handleSubmit = () => {
        // Preparar formValues con traducciones
        const formValuesWithTranslations = {
            ...formValues,
            translations: translations
        };

        axios.post(ProjectConfig.api_url, formValuesWithTranslations, {
            params: {
                request: 'add_edit_textos_liturgicos'
            }
        })
        .then(function (response) {
            console.log(response);
            navigate('/admin/textos_liturgicos');
        })
        .catch(function (error) {
            console.log(error);
        })
        .finally(function () {});
    }

    return (
        <>
            <div id="textosLiturgicosForm">
                <div className="textosLiturgicosForm_right">
                    <Box id="textos_liturgicos_editor" className="box_editor" title="Texto litúrgico" subtitle="Editor">
                        {/* TABS DE IDIOMAS */}
                        <LangTabs currentLangId={currentLangId} onChange={handleLangChange} />

                        <div className='input_group'>
                            {/* Campos no traducibles - Solo en español */}
                            {currentLangId === "1" && (
                            <div className='input_column'>
                                <TextField
                                    id="tiempo"
                                    name="tiempo"
                                    label="Tiempo"
                                    type="text"
                                    required
                                    select
                                    fullWidth
                                    size="small"
                                    value={formValues.tiempo}
                                    onChange={(e) => setFormValues((prev: any) => ({...prev, tiempo: e.target.value}))}
                                >
                                    <MenuItem value="tiempo_ordinario">Tiempo ordinario</MenuItem>
                                    <MenuItem value="cuaresma">Cuaresma</MenuItem>
                                    <MenuItem value="semana_santa">Semana Santa</MenuItem>
                                    <MenuItem value="pascua">Pascua</MenuItem>
                                    <MenuItem value="adviento">Adviento</MenuItem>
                                    <MenuItem value="navidad">Navidad</MenuItem>
                                </TextField>

                                <TextField
                                    id="dia"
                                    name="dia"
                                    label="Día"
                                    type="text"
                                    required
                                    select
                                    fullWidth
                                    size="small"
                                    value={formValues.dia}
                                    onChange={(e) => setFormValues((prev: any) => ({...prev, dia: e.target.value}))}
                                    >
                                    <MenuItem value="0">Domingo</MenuItem>
                                    <MenuItem value="1">Lunes</MenuItem>
                                    <MenuItem value="2">Martes</MenuItem>
                                    <MenuItem value="3">Miércoles</MenuItem>
                                    <MenuItem value="4">Jueves</MenuItem>
                                    <MenuItem value="5">Viernes</MenuItem>
                                    <MenuItem value="6">Sábado</MenuItem>
                                </TextField>

                                <TextField
                                    id="semana"
                                    name="semana"
                                    label="Semana"
                                    type="text"
                                    required
                                    select
                                    fullWidth
                                    size="small"
                                    value={formValues.semana}
                                    onChange={(e) => setFormValues((prev: any) => ({...prev, semana: e.target.value}))}
                                    >
                                    {semanaArray.map( (item,index) => (
                                        <MenuItem key={index} value={index+1}>{index+1}</MenuItem>
                                    ))}
                                </TextField>

                                <TextField
                                    id="color"
                                    name="color"
                                    label="Color"
                                    type="text"
                                    required
                                    select
                                    fullWidth
                                    size="small"
                                    value={formValues.color}
                                    onChange={(e) => {
                                        setFormValues((prev: any) => ({...prev, color: e.target.value}));
                                    }}
                                >
                                    <MenuItem value="Verde">Verde</MenuItem>
                                    <MenuItem value="Blanco">Blanco</MenuItem>
                                    <MenuItem value="Morado">Morado</MenuItem>
                                    <MenuItem value="Rojo">Rojo</MenuItem> 
                                </TextField>
                            </div>
                            )}



                            <div className='input_row'>
                                <div className='input_label_group'>
                                    <Typography
                                        variant="body1"
                                        sx={{fontWeight: '500', mb: '10px', mt: '5px'}}
                                    >
                                        Oficio de lectura
                                    </Typography>

                                    <App
                                        key={`oficio-${currentLangId}`}
                                        handleEditorChange={handleOficioChange}
                                        content={oficio}
                                        placeholder=""
                                        />
                                </div>

                                <div className='input_label_group'>
                                    <Typography
                                        variant="body1"
                                        sx={{fontWeight: '500', mb: '10px', mt: '5px'}}
                                    >
                                        Laudes
                                    </Typography>

                                    <App
                                        key={`laudes-${currentLangId}`}
                                        handleEditorChange={handleLaudesChange}
                                        content={laudes}
                                        placeholder=""
                                        />
                                </div>
                                
                                <div className='input_label_group'>
                                    <Typography
                                        variant="body1"
                                        sx={{fontWeight: '500', mb: '10px', mt: '5px'}}
                                    >
                                        Horas intermedias
                                    </Typography>

                                    <App
                                        key={`horas-${currentLangId}`}
                                        handleEditorChange={handleHorasChange}
                                        content={horas}
                                        placeholder=""
                                        />
                                </div>
                                
                                <div className='input_label_group'>
                                    <Typography
                                        variant="body1"
                                        sx={{fontWeight: '500', mb: '10px', mt: '5px'}}
                                    >
                                        Vísperas
                                    </Typography>

                                    <App
                                        key={`visperas-${currentLangId}`}
                                        handleEditorChange={handleVisperasChange}
                                        content={visperas}
                                        placeholder=""
                                        />
                                </div>

                                <div className='input_label_group'>
                                    <Typography
                                        variant="body1"
                                        sx={{fontWeight: '500', mb: '10px', mt: '5px'}}
                                    >
                                        Completas
                                    </Typography>

                                    <App
                                        key={`completas-${currentLangId}`}
                                        handleEditorChange={handleCompletasChange}
                                        content={completas} 
                                        placeholder=""
                                        />
                                </div>

                                <div className='input_label_group'>
                                    <Typography
                                        variant="body1"
                                        sx={{fontWeight: '500', mb: '10px', mt: '5px'}}
                                    >
                                        Lecturas año 1
                                    </Typography>

                                    <App
                                        key={`lecturas1-${currentLangId}`}
                                        handleEditorChange={handleLecturasAño1Change}
                                        content={lecturasAño1}
                                        placeholder=""
                                        />
                                        <Typography
                                        variant="body1"
                                        sx={{fontWeight: '500', mb: '10px', mt: '5px'}}
                                    >
                                        Reflexiones año 1
                                    </Typography>
                                    <App
                                        key={`reflexiones1-${currentLangId}`}
                                        handleEditorChange={handleLecturasAño1ChangeReflexiones}
                                        content={lecturasAño1reflexiones}
                                        placeholder=""
                                        />
                                        <Typography
                                        variant="body1"
                                        sx={{fontWeight: '500', mb: '10px', mt: '5px'}}
                                    >
                                        Lectio divina año 1
                                    </Typography>
                                    <App
                                        key={`lectio1-${currentLangId}`}
                                        handleEditorChange={handleLecturasAño1ChangeLeticio}
                                        content={lecturasAño1lectio_divina}
                                        placeholder=""
                                        />
                                </div>
                                
                                <div className='input_label_group'>
                                    <Typography
                                        variant="body1"
                                        sx={{fontWeight: '500', mb: '10px', mt: '5px'}}
                                    >
                                        Lecturas año 2
                                    </Typography>

                                    <App
                                        key={`lecturas2-${currentLangId}`}
                                        handleEditorChange={handleLecturasAño2Change}
                                        content={lecturasAño2}
                                        placeholder=""
                                        />
                                                                            <Typography
                                        variant="body1"
                                        sx={{fontWeight: '500', mb: '10px', mt: '5px'}}
                                    >
                                        Reflexiones año 2
                                    </Typography>
                                    <App
                                        key={`reflexiones2-${currentLangId}`}
                                        handleEditorChange={handleLecturasAño2ChangeReflexiones}
                                        content={lecturasAño2reflexiones}
                                        placeholder=""
                                        />
                                        <Typography
                                        variant="body1"
                                        sx={{fontWeight: '500', mb: '10px', mt: '5px'}}
                                    >
                                        Lectio divina año 2
                                    </Typography>
                                    <App
                                        key={`lectio2-${currentLangId}`}
                                        handleEditorChange={handleLecturasAño2ChangeLeticio}
                                        content={lecturasAño2lectio_divina}
                                        placeholder=""
                                        />
                                </div>

                                <div className='input_label_group'>
                                    <Typography
                                        variant="body1"
                                        sx={{fontWeight: '500', mb: '10px', mt: '5px'}}
                                    >
                                        Lectura dominical año A
                                    </Typography>

                                    <App
                                        key={`dominicalA-${currentLangId}`}
                                        handleEditorChange={handleDominicalAñoAChange}
                                        content={dominicalAñoA}
                                        placeholder=""
                                        />

                                        <Typography
                                        variant="body1"
                                        sx={{fontWeight: '500', mb: '10px', mt: '5px'}}
                                    >
                                        Reflexiones año A
                                    </Typography>
                                    <App
                                        key={`reflexionesA-${currentLangId}`}
                                        handleEditorChange={handleDominicalAñoAChangeReflexiones}
                                        content={dominicalAñoAreflexiones}
                                        placeholder=""
                                        />
                                        <Typography
                                        variant="body1"
                                        sx={{fontWeight: '500', mb: '10px', mt: '5px'}}
                                    >
                                        Lectio divina año A
                                    </Typography>
                                    <App
                                        key={`lectioA-${currentLangId}`}
                                        handleEditorChange={handleDominicalAñoAChangeLeticio}
                                        content={dominicalAñoAlectio_divina}
                                        placeholder=""
                                        />
                                </div>

                                <div className='input_label_group'>
                                    <Typography
                                        variant="body1"
                                        sx={{fontWeight: '500', mb: '10px', mt: '5px'}}
                                    >
                                        Lectura dominical año B
                                    </Typography>

                                    <App
                                        key={`dominicalB-${currentLangId}`}
                                        handleEditorChange={handleDominicalAñoBChange}
                                        content={dominicalAñoB}
                                        placeholder=""
                                        />
                                        <Typography
                                        variant="body1"
                                        sx={{fontWeight: '500', mb: '10px', mt: '5px'}}
                                    >
                                        Reflexiones año B
                                    </Typography>
                                    <App
                                        key={`reflexionesB-${currentLangId}`}
                                        handleEditorChange={handleDominicalAñoBChangeReflexiones}
                                        content={dominicalAñoBreflexiones}
                                        placeholder=""
                                        />
                                        <Typography
                                        variant="body1"
                                        sx={{fontWeight: '500', mb: '10px', mt: '5px'}}
                                    >
                                        Lectio divina año B
                                    </Typography>
                                    <App
                                        key={`lectioB-${currentLangId}`}
                                        handleEditorChange={handleDominicalAñoBChangeLeticio}
                                        content={dominicalBñoBlectio_divina}
                                        placeholder=""
                                        />
                                </div>
                                
                                <div className='input_label_group'>
                                    <Typography
                                        variant="body1"
                                        sx={{fontWeight: '500', mb: '10px', mt: '5px'}}
                                    >
                                        Lectura dominical año C
                                    </Typography>

                                    <App
                                        key={`dominicalC-${currentLangId}`}
                                        handleEditorChange={handleDominicalAñoCChange}
                                        content={dominicalAñoC}
                                        placeholder=""
                                        />
                                        <Typography
                                        variant="body1"
                                        sx={{fontWeight: '500', mb: '10px', mt: '5px'}}
                                    >
                                        Reflexiones año C
                                    </Typography>
                                    <App
                                        key={`reflexionesC-${currentLangId}`}
                                        handleEditorChange={handleDominicalAñoCChangeReflexiones}
                                        content={dominicalAñoCreflexiones}
                                        placeholder=""
                                        />
                                        <Typography
                                        variant="body1"
                                        sx={{fontWeight: '500', mb: '10px', mt: '5px'}}
                                    >
                                        Lectio divina año C
                                    </Typography>
                                    <App
                                        key={`lectioC-${currentLangId}`}
                                        handleEditorChange={handleDominicalAñoCChangeLeticio}
                                        content={dominicalAñoClectio_divina}
                                        placeholder=""
                                        />
                                </div>
                            </div>
                        </div> 
                
                        <div className='buttons'>
                            <Button
                                onClick={() => {
                                    navigate('/admin/textos_liturgicos', { replace: true })
                                }}
                                variant="outlined"
                                className="button_2"
                            >
                                Cancelar
                            </Button>
                            
                            <Button
                                onClick={handleSubmit}
                                variant="contained"
                                className="button_1"
                            >
                                Guardar
                            </Button>
                        </div>
                    </Box>
                </div>
            </div>
        </>
    );
}